import styled, { keyframes } from 'styled-components';
import theme from '../../../theme';

const spin = keyframes`
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
`;

const fadeIn = keyframes`
    from { opacity: 0; }
    to { opacity: 1; }
`;

export const Overlay = styled.div`
    position: absolute;
    inset: 0;
    z-index: 9998;
    background: rgba(200, 210, 220, 0.45);
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding-top: 15%;
    animation: ${fadeIn} 0.2s ease;
`;

export const PanelContainer = styled.div`
    z-index: 9999;
    background: #f4f4f4;
    box-shadow: #ccc 0 2px 15px -8px;
    border: 1px solid #aaa;
    border-radius: 3px;
    padding: 20px 28px;
    min-width: 380px;
    max-width: 480px;
    animation: ${fadeIn} 0.2s ease;
`;

export const HeaderRow = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const HeaderLabel = styled.span`
    color: ${theme.colors.text.heading};
    font-size: 1rem;
    font-weight: 600;
`;

export const ProgressFraction = styled.span`
    margin-left: auto;
    font-size: 0.875rem;
    color: ${theme.colors.text.lightGrey};
    white-space: nowrap;
    padding-right: 4px;
`;

export const ExpandButton = styled.button`
    background: none;
    border: none;
    cursor: pointer;
    padding: 0 2px;
    font-size: 0.7rem;
    color: ${theme.colors.text.lightGrey};
    line-height: 1;
    display: flex;
    align-items: center;
    flex-shrink: 0;
    &:hover {
        color: ${theme.colors.text.primary};
    }
`;

export const DetailSection = styled.div`
    border-top: 1px solid #ddd;
    margin-top: 8px;
    padding-top: 8px;
`;

export const LoaderItemRow = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 6px;
    font-size: 0.95rem;
    color: ${theme.colors.text.primary};
`;

export const CheckmarkIcon = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    color: ${theme.colors.text.green};
    font-size: 16px;
    font-weight: 700;
    flex-shrink: 0;
`;

export const SmallSpinner = styled.span`
    display: inline-block;
    width: 18px;
    height: 18px;
    border: 2px solid #ccc;
    border-top-color: ${theme.colors.text.primary};
    border-radius: 50%;
    animation: ${spin} 0.75s linear infinite;
    flex-shrink: 0;
`;
